import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { Provider } from "react-redux";
import { PersistGate } from "redux-persist/integration/react";
import { Toaster } from "react-hot-toast";
import store, { persistor } from "./store/index";

import ErrorBoundary from "./components/ErrorBoundary";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <Provider store={store}>
    <PersistGate loading={null} persistor={persistor}>
      <ErrorBoundary>
        <App />
        <Toaster
          toastOptions={{
            position: "top-right",
            style: {
              background: "white",
              color: "black",
            },
          }}
        />
      </ErrorBoundary>
    </PersistGate>
  </Provider>,
);

reportWebVitals();
